import { AssistantValue } from "../../../../services/api/instances/assistantsApi/types";
import { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";

export const getFilteredAssistantObjects = (
  assistants: NormalizedStorageObject<AssistantValue>[]
) => assistants.filter((assistant) => assistant.value !== null);
